// startup
// Load entry module and return exports
__webpack_modules__["./src/components/carousel/carousel.js"]();
__webpack_modules__["./src/components/carousel/_carousel.scss"]();
// This entry module doesn't tell about it's top-level declarations so it can't be inlined
var __webpack_exports__ = {};
__webpack_modules__["?6190"]();
